// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__QMNE4","empty":"ModalGraph_empty__2kGi5"};